import ElgigantenMonza from "/static/images/leaderboard/tracks/Monza_ELGIGANTEN.svg";
// import MapleValley from "/static/images/leaderboard/tracks/Maple_Valley_v2 (1).svg";
import GrandOak from "/static/images/leaderboard/tracks/grand_oak.svg";

// import LogitechMonza from "/static/images/leaderboard/tracks/Monza_LOGITECH.svg";

export const RacingTracks = {
  "elgiganten-nbxpa": ElgigantenMonza,
  "logitech-l5vzz": GrandOak,
  "LEGO-gdjkr": null,
};
